export const GEORGIAN_NUMBER_LENGTH = 9;
